import { scaleLinear } from '@visx/scale'
import dayjs from 'dayjs'

import { NO_DATE_SYMBOL } from '../../util/constants'
import { ARROW_LINE_HORIZONTAL_PADDING, DOT_RADIUS } from './constants'

const NO_DATE_DOT_POSITION = DOT_RADIUS + 2

export const useTimelineScale = ({
  timeLineWidthPx,
  startDate,
  endDate,
}: {
  timeLineWidthPx: number
  startDate: Date
  endDate: Date
}) => {
  const noDateDotWidth = 2 * DOT_RADIUS + ARROW_LINE_HORIZONTAL_PADDING
  const timeLineWidthExcludingNoDateDot = timeLineWidthPx - noDateDotWidth
  const pixelsToDateTime = scaleLinear({
    domain: [ARROW_LINE_HORIZONTAL_PADDING, timeLineWidthExcludingNoDateDot],
    range: [startDate.getTime(), endDate.getTime()],
    round: true,
  })
  const dateTimeToPixels = scaleLinear({
    domain: [startDate.getTime(), endDate.getTime()],
    range: [ARROW_LINE_HORIZONTAL_PADDING, timeLineWidthExcludingNoDateDot],
  })

  return {
    pixelsToDate: (xCoord: number) =>
      dayjs(pixelsToDateTime(xCoord - noDateDotWidth))
        .local()
        .toDate(),
    dateToPixel: (d: Date | symbol) => {
      if (d === NO_DATE_SYMBOL) {
        return NO_DATE_DOT_POSITION
      }

      if (typeof d === 'symbol') {
        throw new Error('Invalid date symbol provided to dateToPixel function')
      }

      return dateTimeToPixels(d.getTime()) + noDateDotWidth
    },
  }
}
